import { useState, useEffect } from 'react';

/**
 * Returns a scroll progress value between 0 and 1 based on how far
 * the user has scrolled down the current page.
 */
export function useScrollProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const updateProgress = () => {
      const scrollableHeight =
        document.documentElement.scrollHeight - window.innerHeight;

      if (scrollableHeight <= 0) {
        setProgress(0);
        return;
      }

      setProgress(Math.min(1, window.scrollY / scrollableHeight));
    };

    window.addEventListener('scroll', updateProgress, { passive: true });
    // Capture initial state (e.g. when navigating to an anchored URL)
    updateProgress();

    return () => window.removeEventListener('scroll', updateProgress);
  }, []);

  return progress;
}
